module.exports = __webpack_public_path__ + "static/media/04_a.525d1971.png";